import React from 'react'
import NumberFormat, { NumberFormatProps } from 'react-number-format'

export default function FormattedNumberInput(
  props: JSX.IntrinsicAttributes & JSX.IntrinsicClassAttributes<NumberFormat> & Readonly<NumberFormatProps>
) {
  return (
    <NumberFormat
      className={`FormInput ${props.className}`}
      pattern="[0-9,]*"
      inputMode="numeric"
      isNumericString
      thousandSeparator
      allowNegative={false}
      decimalScale={0}
      {...props}
    />
  )
}
